import { cn } from "@/lib/utils";

interface BrandLoaderProps {
  /** Diameter of the spinning mark in pixels. */
  size?: number;
  /** Optional caption rendered beneath the mark. */
  label?: string;
  /** Center within the full viewport height. */
  fullscreen?: boolean;
  className?: string;
}

/**
 * Branded loading indicator: the generated concierge "loading mark" masked to
 * a circle and eased through a slow rotation, wrapped by a breathing ring.
 */
export function BrandLoader({ size = 56, label, fullscreen, className }: BrandLoaderProps) {
  return (
    <output
      className={cn(
        "flex flex-col items-center justify-center gap-3 text-muted-foreground",
        fullscreen && "h-dvh",
        className
      )}
    >
      <span className="brand-loader" style={{ width: size, height: size }}>
        <img src="/brand/loading-mark.png" alt="" />
      </span>
      {label ? (
        <span className="font-display text-sm tracking-tight text-foreground/70">{label}</span>
      ) : (
        <span className="sr-only">불러오는 중</span>
      )}
    </output>
  );
}
